import { Routes, Route, Navigate } from "react-router-dom";

import NotFoundPage from "./../../pages/Page/NotFoundPage/NotFoundPage";
import PublicLayout from "../../layouts/PublicLayout/PublicLayout";
import LandingPage from "../../pages/Public/LandingPage/LandingPage";

const PublicContainer = () => {
  return (
    <PublicLayout>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </PublicLayout>
  );
};

export default PublicContainer;
